import { render, staticRenderFns } from "./archivesCenter.vue?vue&type=template&id=3c8432de&scoped=true"
import script from "./archivesCenter.vue?vue&type=script&lang=js"
export * from "./archivesCenter.vue?vue&type=script&lang=js"
import style0 from "./archivesCenter.vue?vue&type=style&index=0&id=3c8432de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8432de",
  null
  
)

export default component.exports